import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import isMaterialWarehouse from '@/common/is-warehouse.js';
import { mapState } from 'vuex';

export default {
  data: function data() {
    return {
      layoutStyle: {},
      throttled: null
    };
  },


  computed: _extends({}, mapState({
    isCommonTemplatePage: function isCommonTemplatePage(state) {
      return state.creative.template.isCommonTemplatePage;
    }
  })),

  mounted: function mounted() {
    this.setLayoutStyle();
    this.throttled = _.throttle(this.resizeHandler, 100);
    window.addEventListener('resize', this.throttled);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.throttled);
  },


  methods: {
    resizeHandler: function resizeHandler() {
      this.setLayoutStyle();
    },
    setLayoutStyle: function setLayoutStyle() {
      // 不同站点头部高度不一样
      var navHeight = 48;
      if (isMaterialWarehouse()) {
        // 如果是通用模板的模板制作，会有皮肤组件
        if (this.isCommonTemplatePage) {
          navHeight = 80;
        } else {
          navHeight = 50;
        }
      }
      this.layoutStyle = {
        height: window.innerHeight - navHeight + 'px'
      };
    }
  }
};